import { Text, Box, Flex, Icon } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { FaCircle } from "react-icons/fa6";

export const YIELD_TEXT_STRINGS = {
  HEADER: {
    TITLE: "High Growth Vault",
    STATS: {
      TVL: "VAULT TVL",
      APY: "ESTIMATED APY",
    },
  },
  SECTIONS: {
    DEPOSIT_WITHDRAW: {
      TABS: [
        { key: "deposit", title: "Deposit" },
        { key: "withdraw", title: "Withdraw" },
        // { key: "bridge", title: "Bridge" },
      ],
      DISCLAIMER: {
        DEPOSIT: "",
        WITHDRAW: (
          <>
            The withdrawal amount will be{" "}
            <Box as="span" fontWeight="500" color="textPrimary">
              auto-claimed
            </Box>{" "}
            to your address in 3-4 days once you request a withdrawal. Check
            pending claims in the ‘Claims’ section. While in the withdrawal
            queue, you will not earn any position rewards or points. All your
            withdrawals in a day will be fulfilled as a single transaction.
          </>
        ),
      },
      BRIDGE: {
        heading: "You can bridge your hgETH to 9 active L2s.",
        supported: [
          {
            chain: "Linea",
            icon: "/assets/chains/linea.svg",
          },
          {
            chain: "Optimism",
            icon: "/assets/chains/optimism.svg",
          },
          {
            chain: "Scroll",
            icon: "/assets/chains/scroll.svg",
          },
          {
            chain: "ZKSync",
            icon: "/assets/chains/zksync.svg",
          },
          {
            chain: "Blast",
            icon: "/assets/chains/blast.png",
          },
          {
            chain: "Mode",
            icon: "/assets/chains/mode.svg",
          },
          {
            chain: "Base",
            icon: "/assets/chains/base.svg",
          },
          {
            chain: "Zircuit",
            icon: "/assets/chains/zircuit.svg",
          },
          {
            chain: "Manta Pacific",
            icon: "/assets/bridge/manta-pacific.svg",
          },
        ],
      },
    },
    PORTFOLIO: {
      TABS: [
        { key: "holdings", title: "My Holdings" },
        // { key: "points", title: "My points", tag: "Calculate points" },
        { key: "claims", title: "Claims" },
        { key: "apr_reports", title: "APR reports", isNew: true },
      ],
      HOLDINGS: {
        walletConnect: "Connect your wallet to view your holdings",
        nexusMutual: {
          title:
            "Insure your hgETH with Nexus Mutual. 10% discount for Gain users.",
          CTA: "Get insurance",
          imgSrc: "/assets/vaults/nexus.svg",
        },
      },
      POINTS: {
        walletConnect: "Connect wallet to view your points",
        supported: [
          // {
          //   key: "linea",
          //   title: "Linea",
          //   tag: "Boosted",
          //   logo: "/assets/vaults/karak.svg",
          // },
          // {
          //   key: "scroll",
          //   title: "Scroll",
          //   tag: "Top Marks",
          //   logo: "/assets/vaults/karak.svg",
          // },
          // {
          //   key: "karak",
          //   title: "Karak",
          //   tag: "Boosted",
          //   logo: "/assets/vaults/karak.svg",
          // },
          // {
          //   key: "kernel",
          //   title: "Kernel Points",
          //   tag: "3x (Boosted)",
          //   logo: "/assets/kernel.svg",
          // },
          // {
          //   key: "eigen",
          //   title: "$Eigen Rewards",
          //   tag: "1x",
          //   logo: "/assets/vaults/karak.svg",
          // },
          // {
          //   key: "infra",
          //   title: "Infra Partner Points",
          //   tag: "3x",
          //   logo: "/assets/vaults/karak.svg",
          // },
          // {
          //   key: "turtle_linea_LXP",
          //   title: "Turtle Linea LXP-L",
          //   tag: "5% boost",
          //   logo: "/assets/vaults/karak.svg",
          // },
          // {
          //   key: "turtle_kelp",
          //   title: "Turtle Kelp Miles",
          //   tag: " 50% boost",
          //   logo: "/assets/vaults/karak.svg",
          // },
          // {
          //   key: "turtle_linea_veteran",
          //   title: "Turtle Linea Veteran",
          //   tag: " 5% boost",
          //   logo: "/assets/vaults/karak.svg",
          // },
        ],
      },
      CLAIMS: {
        walletConnect: "Connect wallet to view your claims",
        noData: "No claims data available",
        COLUMNS: ["Asset", "Amount", "Status"],
      },
      HISTORY: {
        walletConnect: "Connect wallet to view your history",
        COLUMNS: ["Date", "Time", "Transaction", "Asset", "Amount", "Status"],
      },
      APR_REPORTS: {
        walletConnect: "Connect wallet to view your history",
        cmsKey: "high_growth_vault",
        COLUMNS: [
          {
            name: "Strategy",
            key: "strategy_name",
            hasImage: true,
          },
          {
            name: "Allocation %",
            isNumeric: true,
            key: "allocation",
          },
          {
            name: "APR",
            isNumeric: true,
            key: "apr",
          },
          {
            name: "APR on allocation",
            isNumeric: true,
            key: "apr_on_allocation",
          },
        ],
      },
    },
    OVERVIEW: {
      TABS: [
        { key: "overview", title: "Overview" },
        // { key: "performance", title: "Performance" },
        { key: "strategies", title: "Strategies" },
        // { key: "reserve", title: "Reserve" },
      ],
      DATA: {
        MAIN: {
          heading:
            "High Growth Vault provides highest possible rewards from top DeFi protocols & professional risk management.",
          desc: "Assets are deposited in AAVE, Compound, and Usual among other strategies to generate top-tier rewards. All deposits into this vault issue a liquid token hgETH that can be further used in DeFi for additional yields.",
          disclaimerLink:
            "https://docs.google.com/document/d/1KnAvqWDWXr-GpU3c1g_CtQU6y1fpxX9oaGRcrx4lcWQ",
        },
        FEES: {
          heading: "Fees & Details",
          data: [
            {
              key: "platform",
              title: "PLATFORM FEE",
              value: "1%",
              offerValue: "0%",
              tooltip:
                "Annual fee charged for managing the vault. Waived off until June'25",
            },
            {
              key: "performance",
              title: "PERFORMANCE FEE",
              value: "20%",
              offerValue: "0%",
              tooltip:
                "Annual fee charged on rewards generated by the vault. Waived off until June'25",
            },
            {
              key: "redemption",
              title: "REDEMPTION PERIOD",
              value: "3 days",
            },
          ],
        },
        PARTNERS: {
          heading: "Vault Partners",
          details: [
            {
              key: "ultrayield",
              imgSrc: "/assets/vaults/ultrayield.svg",
              link: "https://kelp.gitbook.io/kelp/kelp-gain/high-growth-gain#vault-partners",
              imageWidth: 140,
            },
            {
              key: "upshift",
              imgSrc: "/assets/vaults/upshift.svg",
              link: "https://kelp.gitbook.io/kelp/kelp-gain/high-growth-gain#vault-partners",
              imageWidth: 100,
            },
          ],
        },
      },
      STRATEGIES: {
        COLUMNS: [
          {
            label: "Protocol",
            accessor: "protocol",
            render: (row: any) => (
              <Flex align="center" gap={2}>
                {row.icon_src ? (
                  <BaseImage
                    src={row.icon_src}
                    alt=""
                    width={14}
                    height={14}
                    style={{ borderRadius: "50%" }}
                  />
                ) : (
                  <Icon as={FaCircle} boxSize={3} color="black" />
                )}
                <Text fontSize="14px" lineHeight="16px" fontWeight="600">
                  {row.protocol}
                </Text>
              </Flex>
            ),
          },
          {
            label: "Position",
            accessor: "strategy",
          },
          {
            label: "Allocation",
            accessor: "allocation",
            render: (row: any, allocations: any) => {
              return (
                <Text fontSize="14px" lineHeight="16px" fontWeight="600">
                  {row.key && allocations[row.key]
                    ? `${allocations[row.key]}%`
                    : "-"}
                </Text>
              );
            },
          },
        ],
        ROWS: [
          {
            protocol: "Aave v3",
            icon_src: "/assets/services/aave.svg",
            strategy: "Leverage",
            allocation: "-",
            key: "aave",
          },
          {
            protocol: "Morpho Blue",
            icon_src: "/assets/services/morpho.svg",
            strategy: "Collateral Buffer",
            allocation: "-",
            key: "morpho",
          },
          // TODO: WILL BE SHOWING SAME AS APR REPORT

          {
            protocol: "Treehouse",
            icon_src: "/assets/platforms/treehouse.jpg",
            strategy: "tETH",
            allocation: "-",
            key: "treehouse",
          },
          {
            protocol: "Kelp",
            icon_src: "/assets/kelp_icon.svg",
            strategy: "rsETH",
            allocation: "-",
            key: "kelp",
          },
          {
            protocol: "Compound",
            strategy: "Leverage",
            allocation: "-",
            icon_src: "/assets/ecosystem/defi/compound.svg",
            key: "compound",
          },
        ],
      },
      RESERVES: {
        COLUMNS: ["Date", "Time", "Block", "Asset", "Amount", "Txn"],
      },
    },
  },
};
